module.exports = __webpack_public_path__ + "./c8c4be10c80d088db5a510aec528a2c6-icon-service-marathon-large@2x.png";


//////////////////
// WEBPACK FOOTER
// ./plugins/services/src/img/icon-service-marathon-large@2x.png
// module id = 1087
// module chunks = 0